<template id="Vehicule">
	<div class="vehicule">
		<span @click="cleanVehicule()" class="material-icons md-30 md-dark close">close</span>
		<div class="version">
			<img v-if="show_logo()" :src="get_logo_url()"><h3>{{this.$store.state.vehicule.Marque}} {{this.$store.state.vehicule.Modele}} {{this.$store.state.vehicule.Version}}</h3>
		</div>
		<div class="informations">
			<div>
				<p>Immatriculation : {{this.$store.state.vehicule.immat}}</p>
				<p>Numéro de série : {{this.$store.state.vehicule.VIN}}</p>
				<p>Date de mise en circulation : {{this.$store.state.vehicule.DateMEC}}</p>
			</div>
			<div>
				<p>Energie : {{this.$store.state.vehicule.Energie}}</p>
				<p>Puissance DIN : {{this.$store.state.vehicule.PuissCh}}</p>
				<p>Puissance fiscale : {{this.$store.state.vehicule.PuissFisc}}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Vehicule',
	data () {
		return {
			logos:[
				"ALFA ROMEO",
				"AUDI",
				"BMW",
				"B.M.W",
				"B.M.W.",
				"CHEVROLET",
				"CITROEN",
				"DACIA",
				"FIAT",
				"FORD",
				"HONDA",
				"HYUNDAI",
				"JAGUAR",
				"JEEP",
				"KIA",
				"LAND ROVER",
				"LEXUS",
				"MAZDA",
				"MERCEDES-BENZ",
				"MERCEDES",
				"MINI",
				"NISSAN",
				"OPEL",
				"PEUGEOT",
				"PORSCHE",
				"RENAULT",
				"SEAT",
				"SKODA",
				"SMART",
				"SUZUKI",
				"TESLA",
				"TOYOTA",
				"VOLKSWAGEN",
				"VOLVO",
				"YAMAHA"
			]
		}
	},
	methods:{
		show_logo(){
			if(this.logos.includes(this.$store.state.vehicule.Marque)){
				return true
			}else{
				return false;
			}
		},
		get_logo_url(){
				var images = require.context('../assets/logos_vehicules/', false, /\.png$/)
    			return images('./' + this.$store.state.vehicule.Marque + ".png")			
		},
		cleanVehicule() {
			this.$store.commit('cleanVehicule');
		}
	}
}
</script>

<style scoped>

.vehicule{
	background-color: #fbfbfb;
	border-radius: 5px;
	padding:10px;
	display:flex;
	flex-flow: column;
	align-items:center;
}
.informations{
	display: flex;
	flex-flow: row wrap;
	margin-top: 15px;
}
.informations > div{
	padding-left: 15px;
	padding-right: 15px;
}
.vehicule p{
	margin: 0px;
	padding:0px;
}
.version{
	display: flex;
	justify-content:center;
	align-items:center;
}
.version img{
	height: 80px;
	margin-right:30px;
}

.close{
	position:relative;
	cursor:pointer;
	left: 210px;
	margin-bottom:-25px;
}

	@media all and (max-width: 515px) {
		.close{
			position: absolute;
		left: inherit;
		right: 15px;
	}
		.version{
			margin-top:15px;
		}
}

</style>



// WEBPACK FOOTER //
// src/components/Vehicule.vue